import { useEffect } from 'react';
import { Switch, Route } from 'react-router-dom';

import { Path } from 'components/_hooks/use-router';
import { LocalStore } from 'constants/localstore';
import { useAuthNavigator } from 'components/_hooks/use-router';
import { AuthResetCode } from './components/auth-reset-code';
import { AuthResetPass } from './components/auth-reset-pass';
import { AuthHeader } from './components/auth-header';
import { AuthFooter } from './components/auth-footer';
import { AuthLogin } from './components/auth-login';
import { AuthReg } from './components/auth-reg';
import styles from './_auth.module.scss';
import { AuthActivateAcc } from './components/auth-activate-acc.tsx';

export const Auth = () => {
  const { navigateTo } = useAuthNavigator();

  useEffect(() => {
    const token = localStorage.getItem(LocalStore.token);
    const source = new URLSearchParams(window.location.search).get('s');
    if (token) navigateTo(Path.app);
    else if (source) navigateTo(Path.register, window.location.search);
    else navigateTo(Path.login);
  }, []);

  return (
    <div className={styles.Root}>
      <AuthHeader />
      <div className={styles.Root__body}>
        <Switch>
          <Route path={Path.login} component={AuthLogin} />
          <Route path={Path.resetCode} component={AuthResetCode} />
          <Route path={Path.resetPassword} component={AuthResetPass} />
          <Route path={Path.register} component={AuthReg} />
          <Route path={Path.activateAcc} component={AuthActivateAcc} />
        </Switch>
      </div>
      <AuthFooter />
    </div>
  );
};
